import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actionCreators } from 'react/api/actions/configEventHttpHeadersModal';
import { getResourceTo } from 'react/utils/utils';
import { v4 as uuid } from 'uuid';
import Modal from 'react/components/Modal';

function HttpRequestModal(props) {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) =>
    state.configEventHttpHeadersModal.get('isOpenModal')
  );
  const headersStore = useSelector((state) =>
    state.configEventHttpHeadersModal.get('headers')
  );
  const [isShowError, setIsShowError] = useState(false);
  const [headers, setHeaders] = useState([]);
  const modalTitleText = getResourceTo('event.postRequestAction.modal.title');
  const modalErrorText = getResourceTo('event.postRequestAction.modal.error');

  useEffect(() => {
    if (headersStore) {
      setHeaders(() =>
        headersStore.reduce((acc, v, k) => {
          acc.push({
            id: uuid(),
            fields: [
              {
                name: uuid(),
                value: k,
                error: false
              },
              {
                name: uuid(),
                value: v,
                error: false
              }
            ]
          });
          return acc;
        }, [])
      );
    }
  }, [isOpen]);

  const closeModal = () => {
    dispatch(actionCreators.closeModal());
    setIsShowError(false);
  };

  const saveModal = () => {
    const currentHeaders = [...headers];
    const currentHeadersValidated = currentHeaders.map((header) => {
      const fields = header.fields.map((field) => {
        if (field.value === '') {
          return { ...field, error: true };
        }
        return { ...field, error: false };
      });

      return { ...header, fields };
    });

    const headersWithError = currentHeadersValidated.filter((header) => {
      const fields = header.fields.filter((field) => field.error);
      if (fields.length) {
        return header;
      }
    });

    const isValidFields = Boolean(headersWithError.length);

    setHeaders(currentHeadersValidated);
    setIsShowError(isValidFields);

    if (!isValidFields) {
      const headersForData = {};
      currentHeadersValidated.forEach(({ fields }) => {
        const [fieldKey, fieldValue] = fields;
        headersForData[fieldKey.value] = fieldValue.value;
      });
      dispatch(actionCreators.updateHeaders(headersForData));
      dispatch(actionCreators.closeModal());
      Greenmile.Event.EventActionUtil.setHttpRequestHeadersPreview(headersForData);
    }
  };

  const handleInputChange = (event, id) => {
    const { value, name } = event.target;
    const currentHeaders = [...headers];
    const currentHeadersUpdated = currentHeaders.map((header) => {
      if (header.id === id) {
        const currentFields = [...header.fields];
        const currentFieldsUpdated = currentFields.map((field) => {
          if (field.name === name) {
            return { ...field, value };
          }
          return field;
        });

        return { ...header, fields: currentFieldsUpdated };
      }
      return header;
    });
    setHeaders(currentHeadersUpdated);
  };

  const addHeader = () => {
    const headerItem = {
      id: uuid(),
      isDefault: false,
      fields: [
        {
          name: uuid(),
          value: '',
          error: false
        },
        {
          name: uuid(),
          value: '',
          error: false
        }
      ]
    };
    setHeaders((prev) => [...prev, headerItem]);
  };

  const removeHeader = (id) => {
    const currentHeaders = [...headers];
    const newHeadersList = currentHeaders.filter((header) => header.id !== id);
    !newHeadersList.length && setIsShowError(false);
    setHeaders(newHeadersList);
  };

  const ModalFooter = (
    <div className="httpRequestModalFooter">
      <button type="button" className="btn-secondary" onClick={closeModal}>
        {getResourceTo('default.button.cancel')}
      </button>
      <button type="button" className="btn-primary" onClick={saveModal}>
        {getResourceTo('default.button.save')}
      </button>
    </div>
  );

  const ModalBody = (
    <div className="httpRequestModalBody">
      <div className="fields-row">
        <div className="input-field">
          <label htmlFor="host">Key</label>
        </div>
        <div className="input-field">
          <label htmlFor="value">Value</label>
        </div>
      </div>
      <div className="fields-row">
        <div className="input-field">
          <div className="input-container">
            <input disabled type="text" value="Content-Type" />
            <div className="icon-help" />
          </div>
        </div>
        <div className="input-field">
          <div className="input-container">
            <input disabled type="text" value="application/json" />
          </div>
        </div>
        <div className="row-buttons">
          {!headers.length && (
            <button onClick={addHeader} type="button">
              +
            </button>
          )}
        </div>
      </div>
      {headers.map((header, index) => {
        const { id, fields } = header;
        const lastIndex = headers.length - 1;
        const isLastItem = lastIndex === index;

        return (
          <div className="fields-row" key={id}>
            {fields.map((field) => (
              <div className="input-field" key={field.name}>
                <div className="input-container">
                  <input
                    name={field.name}
                    type="text"
                    value={field.value}
                    onChange={(e) => handleInputChange(e, id)}
                    className={field.error ? 'error' : ''}
                  />
                </div>
              </div>
            ))}
            <div className="row-buttons">
              {!isLastItem && (
                <button onClick={() => removeHeader(id)} type="button">
                  -
                </button>
              )}
              {isLastItem && (
                <>
                  <button onClick={() => removeHeader(id)} type="button">
                    -
                  </button>
                  <button onClick={addHeader} type="button">
                    +
                  </button>
                </>
              )}
            </div>
          </div>
        );
      })}

      {isShowError && <p>{modalErrorText}</p>}
    </div>
  );

  return (
    <div id="httpRequestModalWrapper">
      <Modal
        isOpen={isOpen}
        title={modalTitleText}
        className="httpRequestModal"
        footer={ModalFooter}
        closeModalFn={closeModal}
        {...props}
      >
        {ModalBody}
      </Modal>
    </div>
  );
}

export default HttpRequestModal;
